import { render, staticRenderFns } from "./InitiateEmailRecoveryDialogue.vue?vue&type=template&id=4b414008&"
import script from "./InitiateEmailRecoveryDialogue.vue?vue&type=script&lang=js&"
export * from "./InitiateEmailRecoveryDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports